module.exports = __webpack_public_path__ + "img/account_journal.d07c26f2.svg";